export default "__VITE_ASSET__Byi_l_RG__"